<hr class="upperline" />
<div class="my-account-form-container terra-error-style" [class.loading-container-overlay]="isLoading">

  <p>You are signed to covercy with these social account </p>

  <div class="form-grid" *ngIf="model">

    <div class="social-login-item" *ngIf="facebookEnabled">
      <img src="/assets/images/logo/facebook-logo.svg" alt="facebook" />
      <h1>Facebook <span class="status">(Enabled)</span></h1>
    </div>

    <div class="social-login-item" *ngIf="googleEnabled">
      <img src="/assets/images/logo/google-logo.jpg" alt="google" />
      <h1>Google <span class="status">(Enabled)</span></h1>
    </div>

    <terra-loader class="full-width" *ngIf="isLoading" centerToParent="true"></terra-loader>

    <div class="form-actions full-width">

    </div>
  </div>
</div>
